// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icon_icon__g4Cm6","writeIcon":"Icon_writeIcon__Nf4WE"};